class MainProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleDiagonalLineOOSButtons();
    window.addEventListener('resize', this.handleDiagonalLineOOSButtons.bind(this));

  }

  handleDiagonalLineOOSButtons() {
    const buttons = this.querySelectorAll('.product-form__input--swatch-label .variant__color-swatch-label--empty, .product-form__input--swatch-label input + label');
    if (!buttons.length) return;

    buttons.forEach((button) => {
      const line = button.querySelector('.diagonal');
      if (!line) return;

      const width = button.offsetWidth;
      const height = button.offsetHeight;

      if (width === 0 || height === 0) return;

      const angleRad = Math.atan(height / width);
      const angleDeg = angleRad * (180 / Math.PI);

      const length = Math.sqrt(width * width + height * height);

      line.style.width = `${length}px`;
      line.style.transform = `rotate(${angleDeg-1}deg)`;
      line.style.height = `2px`;
    });
  }
}

class NovicellMainProduct extends MainProduct {
  constructor() {
    super();
  }
}

customElements.define('main-product', MainProduct);
customElements.define('novicell-main-product', NovicellMainProduct);
